<template>
  <v-dialog
    :value="value"
    max-width="760px"
    persistent
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar
        dense
        dark
        color="deep-orange"
      >
        <v-toolbar-title>
          Ejecutar exportación
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
          icon
          dark
          :disabled="ejecutando"
          @click="cerrar"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-5">
        <!-- Confirmación -->
        <template
          v-if="estado === 'confirmacion'"
        >
          <div class="title mb-4">
            {{
              configuracion
                ? configuracion.nombre
                : ""
            }}
          </div>

          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Grupo
              </div>

              <div class="detalle-value">
                {{ nombreGrupo }}
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Periodo de registro
              </div>

              <div class="detalle-value">
                {{ nombrePeriodo }}
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Formato
              </div>

              <div class="detalle-value">
                {{ formato }}
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Nombre esperado
              </div>

              <div class="detalle-value">
                {{ nombreArchivoEsperado }}
              </div>
            </v-col>

            <v-col cols="12">
              <div class="detalle-label">
                Destino
              </div>

              <div class="detalle-value">
                {{ destinoOneDrive }}
              </div>
            </v-col>
          </v-row>

          <v-alert
            v-if="usarNombreFijo"
            dense
            outlined
            type="warning"
            class="mt-4"
          >
            Esta programación utiliza nombre
            fijo. Si ya existe un archivo con
            ese nombre en OneDrive, será
            reemplazado.
          </v-alert>

          <v-alert
            dense
            outlined
            type="info"
            class="mt-4 mb-0"
          >
            La ejecución será inmediata y no
            modificará el horario ni la próxima
            ejecución programada.
          </v-alert>
        </template>

        <!-- Ejecución -->
        <template
          v-else-if="estado === 'ejecutando'"
        >
          <div
            class="
              text-center
              py-10
            "
          >
            <v-progress-circular
              indeterminate
              color="deep-orange"
              size="72"
              width="6"
            ></v-progress-circular>

            <div
              class="
                title
                mt-6
              "
            >
              Ejecutando exportación...
            </div>

            <div
              class="
                body-2
                grey--text
                mt-2
              "
            >
              Consultando resultados,
              generando el archivo y
              publicándolo en OneDrive.
            </div>

            <v-progress-linear
              indeterminate
              color="deep-orange"
              class="mt-6"
            ></v-progress-linear>
          </div>
        </template>

        <!-- Resultado -->
        <template
          v-else-if="estado === 'resultado'"
        >
          <v-alert
            :type="tipoResultado"
            outlined
            prominent
          >
            <div class="title">
              {{ tituloResultado }}
            </div>

            <div class="mt-1">
              {{ mensajeResultado }}
            </div>
          </v-alert>

          <v-row
            v-if="resultado"
            class="mt-2"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Resultados
              </div>

              <div class="detalle-value">
                {{
                  formatearCantidad(
                    cantidadResultados
                  )
                }}
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="6"
            >
              <div class="detalle-label">
                Tamaño
              </div>

              <div class="detalle-value">
                {{ tamanoArchivo }}
              </div>
            </v-col>

            <v-col
              v-if="nombreArchivo"
              cols="12"
            >
              <div class="detalle-label">
                Archivo
              </div>

              <div class="detalle-value">
                {{ nombreArchivo }}
              </div>
            </v-col>

            <v-col
              v-if="periodoResultado"
              cols="12"
            >
              <div class="detalle-label">
                Periodo de registro
              </div>

              <div class="detalle-value">
                {{
                  periodoResultado
                    .fecha_inicio_actividad
                }}
                →
                {{
                  periodoResultado
                    .fecha_fin_actividad
                }}
              </div>
            </v-col>
          </v-row>

          <v-btn
            v-if="urlArchivo"
            color="primary"
            outlined
            class="mt-4"
            @click="abrirArchivo"
          >
            Abrir archivo
            <v-icon right>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </template>

        <!-- Error -->
        <template
          v-else-if="estado === 'error'"
        >
          <v-alert
            type="error"
            outlined
            prominent
          >
            <div class="title">
              No fue posible ejecutar la
              exportación
            </div>

            <div class="mt-1">
              {{ mensajeError }}
            </div>
          </v-alert>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="estado === 'confirmacion'"
          text
          :disabled="ejecutando"
          @click="cerrar"
        >
          Cancelar
        </v-btn>

        <v-btn
          v-if="estado === 'confirmacion'"
          color="deep-orange"
          dark
          :disabled="
            !configuracion ||
            !configuracion.codigo
          "
          @click="ejecutar"
        >
          Ejecutar ahora
          <v-icon right>
            mdi-play
          </v-icon>
        </v-btn>

        <v-btn
          v-if="
            estado === 'resultado' ||
            estado === 'error'
          "
          text
          @click="cerrar"
        >
          Cerrar
        </v-btn>

        <v-btn
          v-if="estado === 'error'"
          color="deep-orange"
          dark
          @click="ejecutar"
        >
          Intentar nuevamente
          <v-icon right>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  ejecutarExportacionProgramada,
} from "@/utils/exportacionesProgramadasApi";

export default {
  name: "EjecutarExportacionDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    configuracion: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    estado: "confirmacion",
    ejecutando: false,
    resultado: null,
    mensajeError: "",
  }),

  computed: {
    nombreGrupo() {
      return (
        this.configuracion &&
        this.configuracion.grupo &&
        this.configuracion.grupo.nombre
      ) || "Sin grupo";
    },

    nombrePeriodo() {
      const periodo =
        this.configuracion &&
        this.configuracion.periodo
          ? this.configuracion.periodo
          : {};

      const nombres = {
        dia_anterior: "Día anterior",
        dia_actual: "Día actual",
        mes_anterior: "Mes anterior",
      };

      if (
        periodo.tipo === "ultimos_n_dias"
      ) {
        const cantidad =
          periodo.cantidadDias ||
          periodo.cantidad_dias ||
          "";

        return cantidad
          ? `Últimos ${cantidad} días`
          : "Últimos días";
      }

      return (
        nombres[periodo.tipo] ||
        periodo.tipo ||
        "Sin periodo"
      );
    },

    formato() {
      return String(
        this.configuracion &&
        this.configuracion.formato
          ? this.configuracion.formato
          : "csv"
      ).toUpperCase();
    },

    usarNombreFijo() {
      return Boolean(
        this.configuracion &&
        this.configuracion
          .usar_nombre_fijo === true
      );
    },

    nombreArchivoEsperado() {
      const prefijo =
        this.configuracion &&
        this.configuracion.prefijo_archivo
          ? this.configuracion
              .prefijo_archivo
          : "REPORTE";

      const extension =
        this.formato.toLowerCase();

      if (this.usarNombreFijo) {
        return `${prefijo}.${extension}`;
      }

      return (
        `${prefijo}_` +
        "AAAA-MM-DD_HH-mm-ss." +
        extension
      );
    },

    destinoOneDrive() {
      const onedrive =
        this.configuracion &&
        this.configuracion.onedrive
          ? this.configuracion.onedrive
          : null;

      if (!onedrive) {
        return "Sin destino OneDrive";
      }

      const nombre =
        onedrive.nombre || "OneDrive";

      const carpeta =
        onedrive.carpeta || "";

      return carpeta
        ? `${nombre} — ${carpeta}`
        : nombre;
    },

    tipoResultado() {
      if (!this.resultado) {
        return "info";
      }

      if (
        this.resultado.estatus ===
        "sin_datos"
      ) {
        return "info";
      }

      if (
        this.resultado.estatus ===
        "parcial" ||
        this.resultado.correcto === false
      ) {
        return "warning";
      }

      return "success";
    },

    tituloResultado() {
      if (!this.resultado) {
        return "Ejecución finalizada";
      }

      if (
        this.resultado.estatus ===
        "sin_datos"
      ) {
        return "No se encontraron registros";
      }

      if (
        this.resultado.estatus ===
        "parcial"
      ) {
        return (
          "Exportación terminada con " +
          "errores parciales"
        );
      }

      return "Exportación completada";
    },

    mensajeResultado() {
      return (
        this.resultado &&
        this.resultado.mensaje
      ) || "La ejecución terminó correctamente.";
    },

    cantidadResultados() {
      return Number(
        this.resultado &&
        this.resultado.archivo
          ? this.resultado.archivo
              .cantidad_resultados
          : 0
      ) || 0;
    },

    nombreArchivo() {
      return (
        this.resultado &&
        this.resultado.archivo &&
        this.resultado.archivo.nombre
      ) || "";
    },

    periodoResultado() {
      return (
        this.resultado &&
        this.resultado.periodo
      ) || null;
    },

    urlArchivo() {
      return (
        this.resultado &&
        this.resultado.url
      ) || "";
    },

    tamanoArchivo() {
      const bytes = Number(
        this.resultado &&
        this.resultado.archivo
          ? this.resultado.archivo.bytes
          : 0
      );

      if (!bytes) {
        return "0 bytes";
      }

      if (bytes < 1024) {
        return `${bytes} bytes`;
      }

      if (bytes < 1024 * 1024) {
        return (
          `${(bytes / 1024).toFixed(1)} KB`
        );
      }

      return (
        `${(
          bytes /
          (1024 * 1024)
        ).toFixed(1)} MB`
      );
    },
  },

  watch: {
    value(valor) {
      if (valor) {
        this.reiniciar();
      }
    },

    configuracion: {
      deep: true,
      handler() {
        if (
          this.value &&
          !this.ejecutando
        ) {
          this.reiniciar();
        }
      },
    },
  },

  methods: {
    reiniciar() {
      this.estado = "confirmacion";
      this.ejecutando = false;
      this.resultado = null;
      this.mensajeError = "";
    },

    async ejecutar() {
      if (
        !this.configuracion ||
        !this.configuracion.codigo ||
        this.ejecutando
      ) {
        return;
      }

      this.ejecutando = true;
      this.estado = "ejecutando";
      this.resultado = null;
      this.mensajeError = "";

      this.$emit(
        "inicio",
        this.configuracion
      );

      try {
        const resultado =
          await ejecutarExportacionProgramada(
            this.$session,
            this.configuracion.codigo
          );

        this.resultado =
          resultado || {};

        /*
         * El backend puede responder correcto=false
         * para una publicación parcial. Conservamos
         * la respuesta para mostrar sus detalles.
         */
        if (
          resultado &&
          (
            resultado.estatus ===
              "parcial" ||
            resultado.estatus ===
              "sin_datos" ||
            resultado.correcto === true
          )
        ) {
          this.estado = "resultado";

          this.$emit(
            "ejecutada",
            resultado
          );

          return;
        }

        this.mensajeError =
          resultado &&
          resultado.mensaje
            ? resultado.mensaje
            : "No fue posible ejecutar la exportación";

        this.estado = "error";
      } catch (error) {
        console.error(error);

        this.mensajeError =
          error.response &&
          error.response.data &&
          error.response.data.mensaje
            ? error.response.data.mensaje
            : "No fue posible ejecutar la exportación";

        this.estado = "error";
      } finally {
        this.ejecutando = false;

        this.$emit(
          "fin",
          this.configuracion
        );
      }
    },

    cerrar() {
      if (this.ejecutando) {
        return;
      }

      this.$emit("input", false);
    },

    abrirArchivo() {
      if (!this.urlArchivo) {
        return;
      }

      window.open(
        this.urlArchivo,
        "_blank",
        "noopener,noreferrer"
      );
    },

    formatearCantidad(valor) {
      return Number(
        valor || 0
      ).toLocaleString("es-MX");
    },
  },
};
</script>

<style scoped>
.detalle-label {
  color: #757575;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.detalle-value {
  margin-top: 4px;
  color: #212121;
  font-size: 1rem;
  font-weight: 500;
  overflow-wrap: anywhere;
}
</style>
